import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { MAP_LOGO_BY_MODULE } from '../../../__common/map-logo-by-provider'
import { CustomSelectionMenuItem } from '../../../CustomSelectionMenuItem'
import clsx, { ClassValue } from 'clsx'
import { providersByName } from '@indigohive/cogfy-providers'
import { CustomMenuTitleItem } from '../../../CustomMenuTitleItem'

export type ToolFormFilteredMenuProps = {
  onChange: (event: React.ChangeEvent<HTMLSelectElement> | { target: { value: string } }) => void
  options: { value: string, label: ReactNode, disabled?: boolean, displayName?: string }[]
  setSelectEl: (el: HTMLDivElement | null) => void
  searchName: string
  className?: ClassValue
}

export function ToolFormFilteredMenu (props: ToolFormFilteredMenuProps) {
  const { onChange, options, setSelectEl, className } = props
  const { t } = useTranslation()

  const filteredOptions = options.filter(option => option?.label?.toString().toLowerCase().includes(props.searchName.toLowerCase()))

  const optionsProviders = filteredOptions
    .map(filteredOption => filteredOption.label as string)
    .filter(filteredOption => filteredOption.includes('.'))

  const optionsProvidersNames = [...new Set(optionsProviders.map(optionProvider => optionProvider?.split('.')[0]))]

  return (
    <div className={clsx(className)}>
      {filteredOptions.length === 0 && (
        <li>
          <a>
            {t('No options found')}
          </a>
        </li>
      )}
      {filteredOptions
        .filter(item => !(item.label as string)?.includes('.'))
        .map(option => {
          return (
            <CustomSelectionMenuItem
              key={option.value}
              value={option.value}
              label={option.displayName}
              onChange={onChange}
              setSelectEl={setSelectEl}
            />
          )
        })}
      {optionsProvidersNames.map(operation => {
        const moduleName = operation?.toLocaleLowerCase().replace(' ', '')
        const imageSrc = MAP_LOGO_BY_MODULE[moduleName]
        return (
          <span key={operation}>
            {operation && (
              <CustomMenuTitleItem
                imageSrc={imageSrc}
                moduleLabel={providersByName[operation as keyof typeof providersByName]?.label || operation}
                moduleName={moduleName}
              />
            )}
            {filteredOptions
              .filter(option => (option.label as string)?.split('.')[0] === operation)
              .map(operation => (
                <CustomSelectionMenuItem
                  key={operation.value}
                  value={operation.value}
                  label={operation.displayName}
                  onChange={onChange}
                  setSelectEl={setSelectEl}
                />)
              )}
          </span>
        )
      })}
    </div>
  )
}
